export const SELECT_COLLECTION = 'zola/registryCollection/SELECT_COLLECTION';
export const TOGGLE_FACET_VALUE = 'zola/registryCollection/TOGGLE_FACET_VALUE';
export const RESET_FACET_VALUES = 'zola/registryCollection/RESET_FACET_VALUES';
export const UPDATE_SORT = 'zola/registryCollection/UPDATE_SORT';
export const RECEIVE_SEARCH = 'zola/registryCollection/RECEIVE_SEARCH';
export const REQUEST_SEARCH = 'zola/registryCollection/REQUEST_SEARCH';
export const RESET = 'zola/registryCollection/RESET';



/** WEBPACK FOOTER **
 ** ./src/actions/types/RegistryCollectionActionTypes.js
 **/